import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type TemplateAddTemplateItemFragment = { __typename: 'Template', id: string, legacyId: number, name?: string | null, organization: { __typename: 'Organization', id: string, name?: string | null }, galleryImage?: { __typename: 'DataObject', id: string } | null, latestRevision?: { __typename: 'TemplateRevision', id: string, legacyId: number } | null };

export type TemplateAddTemplateItemsQueryVariables = Types.Exact<{
  skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  take?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  filter?: Types.InputMaybe<Types.TemplateFilterInput>;
}>;


export type TemplateAddTemplateItemsQuery = { __typename: 'Query', totalCount: number, items: Array<{ __typename: 'Template', id: string, legacyId: number, name?: string | null, organization: { __typename: 'Organization', id: string, name?: string | null }, galleryImage?: { __typename: 'DataObject', id: string } | null, latestRevision?: { __typename: 'TemplateRevision', id: string, legacyId: number } | null } | null> };

export const TemplateAddTemplateItemFragmentDoc = gql`
    fragment TemplateAddTemplateItem on Template {
  id
  legacyId
  name
  organization {
    id
    name
  }
  galleryImage {
    id
  }
  latestRevision {
    id
    legacyId
  }
}
    `;
export const TemplateAddTemplateItemsDocument = gql`
    query templateAddTemplateItems($skip: Int, $take: Int, $filter: TemplateFilterInput) {
  items: templates(
    skip: $skip
    take: $take
    filter: $filter
    orderBy: [{direction: asc, key: createdAt}]
  ) {
    ...TemplateAddTemplateItem
  }
  totalCount: templatesCount(filter: $filter)
}
    ${TemplateAddTemplateItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TemplateAddTemplateItemsGQL extends Apollo.Query<TemplateAddTemplateItemsQuery, TemplateAddTemplateItemsQueryVariables> {
    override document = TemplateAddTemplateItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }